import { useMemo } from "react";
import CircleGraph from "../CircleGraph";
import { RejectedChartI } from "./RejectedChart.props";

export default function RejectedChart(props: RejectedChartI) {

  const rejectedFraction = useMemo(() => {
    if (!(props.rejected || props.accepted)) return;
    const r = props.rejected || 0;
    const a = props.accepted || 0;
    return r / (a + r);
  }, [props.rejected, props.accepted]);

  const rejectedPercent = useMemo(
    () => Math.round((rejectedFraction || 0) * 100),
    [rejectedFraction]
  );

  return rejectedFraction === undefined ? (
    <></>
  ) : (
    <div title={`Rejected: ${rejectedPercent}%`} className={props.className}>
      <CircleGraph
        angle={rejectedFraction}
        sectorFill='#f44336'
        fill='#7CE299'
        stroke='#002AFF'
        strokeWidth={0.02}
      />
    </div>
  );
}
